import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import bookPrescribed from "../../data/administration/bookPrescribed.json";

interface IBooks {
  headings: Array<string>;
  data: Array<Array<string>>;
}
interface IBookPrescribed {
  title: string;
  defaultExpanded: boolean;
  books: IBooks;
}
const BookPrescribed = () => {
  return (
    <Stack spacing={1}>
      {bookPrescribed?.map(
        (books_for_standard: IBookPrescribed, index: number) => (
          <Accordion
            sx={{ color: "customColors.clr2" }}
            defaultExpanded={books_for_standard?.defaultExpanded}
          >
            <AccordionSummary
              sx={{
                color: "customColors.clr2",
                backgroundColor: "customColors.content_header",
              }}
              expandIcon={
                <ArrowDropDownIcon sx={{ color: "customColors.clr2" }} />
              }
              aria-controls="panel1-content"
              id={`${books_for_standard?.title}`}
            >
              <Typography sx={{ fontFamily: "inherit" }}>
                {books_for_standard?.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                          fontFamily: "inherit",
                        }}
                      >
                        Sr. No.
                      </TableCell>
                      {books_for_standard?.books?.headings?.map(
                        (headers: string, index: number) => (
                          <TableCell
                            align={"left"}
                            key={index}
                            sx={{
                              fontWeight: "bold",
                              fontFamily: "inherit",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {headers}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {books_for_standard?.books?.data?.map(
                      (values: string[], index: number) => (
                        <TableRow key={index}>
                          <TableCell
                            align="center"
                            sx={{
                              fontFamily: "inherit",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {index + 1}
                          </TableCell>
                          {values?.map?.((data: string, rowIndex: number) => (
                            <TableCell
                              align={"left"}
                              key={rowIndex}
                              sx={{
                                fontFamily: "inherit",
                                borderBottom: "1px solid black",
                              }}
                            >
                              {data}
                            </TableCell>
                          ))}
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        )
      )}
    </Stack>
  );
};

export default BookPrescribed;
